import { useEffect, useState } from 'react';

export default function useTypewriter(text, { cps = 28, startDelay = 900, enabled = true } = {}) {
  const [count, setCount] = useState(enabled ? 0 : text.length);

  useEffect(() => {
    if (!enabled) {
      setCount(text.length);
      return undefined;
    }
    let interval;
    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        setCount((c) => {
          if (c >= text.length) {
            clearInterval(interval);
            return c;
          }
          return c + 1;
        });
      }, 1000 / cps);
    }, startDelay);
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [text, cps, startDelay, enabled]);

  return { output: text.slice(0, count), done: count >= text.length };
}
